/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdWebFeaturesAuthAuthenticateWithExternalIdTokens, FxIdWebFeaturesAuthAuthenticateWithExternalIdTokensFromJSONTyped, FxIdWebFeaturesAuthAuthenticateWithExternalIdTokensToJSON, } from './FxIdWebFeaturesAuthAuthenticateWithExternalIdTokens';
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTokensFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTokensFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTokensFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdWebFeaturesAuthAuthenticateWithExternalIdTokens(json)) {
        return FxIdWebFeaturesAuthAuthenticateWithExternalIdTokensFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTokensToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTokensToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTokensToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdWebFeaturesAuthAuthenticateWithExternalIdTokens(value)) {
        return FxIdWebFeaturesAuthAuthenticateWithExternalIdTokensToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseTokens.js.map